export const navSections = [
  { id: "flash", label: "今日速览", icon: "ri-flashlight-line" },
  { id: "board", label: "热搜爆料榜", icon: "ri-fire-line" },
  { id: "zones", label: "全网专区", icon: "ri-earth-line" },
  { id: "collection", label: "吃瓜合集", icon: "ri-folder-chart-line" },
  { id: "featured", label: "深度图文", icon: "ri-article-line" },
  { id: "faq", label: "帮助说明", icon: "ri-question-line" },
];

export const tickerList = [
  "《拾光来信》官宣阵容后热议走高，主演互动细节被逐帧盘点",
  "某综艺录制现场路透流出，嘉宾状态引发新一轮讨论",
  "年度音乐盛典提名名单公布，多个赛道竞争白热化",
  "新片《雾里寻灯》首映口碑出炉，观众评价两极分化",
  "深夜官宣动态持续发酵，评论区画风被网友玩出新花样",
  "跨年晚会在即，各家舞台物料开始提前预热",
  "时尚周看秀生图刷屏，造型师职业素养成热议话题",
  "老牌剧集重播翻红，经典片段被二次创作刷上热门",
];

export interface BoardItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  up: boolean;
  group: string;
}

export const boardList: BoardItem[] = [
  { rank: 1, title: "《拾光来信》开机路透：男女主同框氛围感拉满", tag: "剧集", heat: "982万", up: true, group: "热" },
  { rank: 2, title: "年度音乐盛典提名名单出炉，这五个赛道最意外", tag: "音乐", heat: "763万", up: true, group: "爆" },
  { rank: 3, title: "《雾里寻灯》点映口碑：导演的镜头语言再被夸", tag: "电影", heat: "541万", up: true, group: "热" },
  { rank: 4, title: "跨年晚会阵营曝光，拟邀名单已流出三个版本", tag: "综艺", heat: "488万", up: false, group: "新" },
  { rank: 5, title: "时尚周看秀生图：这套造型师水准被网友封神", tag: "时尚", heat: "402万", up: false, group: "新" },
  { rank: 6, title: "经典剧重播冲上热榜，名场面二次创作席卷短视频", tag: "剧集", heat: "376万", up: true, group: "" },
  { rank: 7, title: "新晋导演首作入围国际影展，家乡影迷集体欢呼", tag: "电影", heat: "311万", up: false, group: "" },
  { rank: 8, title: "某歌手巡演加场开票，三分钟即告售罄", tag: "音乐", heat: "298万", up: true, group: "" },
  { rank: 9, title: "真人秀后期剪辑手法被逐帧讨论，观众直呼上分", tag: "综艺", heat: "214万", up: false, group: "" },
  { rank: 10, title: "颁奖季预热开启，红毯造型预测贴已盖到万楼", tag: "时尚", heat: "167万", up: true, group: "" },
];

export interface ZoneItem {
  id: string;
  name: string;
  emoji: string;
  color: string;
  text: string;
  count: string;
  hot: string;
}

export const zones: ZoneItem[] = [
  { id: "drama", name: "影视圈", emoji: "🎬", color: "bg-accent-100", text: "text-accent-900", count: "1,284 条", hot: "今日 +128" },
  { id: "show", name: "综艺咖", emoji: "🎤", color: "bg-primary-100", text: "text-primary-900", count: "976 条", hot: "今日 +86" },
  { id: "star", name: "饭圈热", emoji: "✨", color: "bg-secondary-100", text: "text-secondary-900", count: "1,002 条", hot: "今日 +93" },
  { id: "fashion", name: "时尚风", emoji: "👗", color: "bg-accent-100", text: "text-accent-900", count: "543 条", hot: "今日 +41" },
  { id: "live", name: "现场派", emoji: "🎟️", color: "bg-primary-100", text: "text-primary-900", count: "398 条", hot: "今日 +35" },
  { id: "talk", name: "话题池", emoji: "💬", color: "bg-secondary-100", text: "text-secondary-900", count: "1,420 条", hot: "今日 +154" },
];

export interface CollectionCard {
  title: string;
  date: string;
  views: string;
  comments: string;
  count: string;
  summary: string;
  image: string;
  tags: string[];
}

export const collectionCards: CollectionCard[] = [
  {
    title: "《拾光来信》开机全记录",
    date: "2026-09-06",
    views: "182.4万",
    comments: "3,208",
    count: "24 条",
    summary: "从选角路透到同框花絮，一场关于新剧的讨论正在发酵，前因后果一次理清。",
    image: "https://readdy.ai/api/search-image?query=film%20set%20warm%20cinematic%20backstage%20soft%20golden%20light%20crew%20camera%20equipment%20editorial%20photography%20cream%20and%20amber%20tones%20minimal%20clean%20composition&width=900&height=620&seq=gua-card-drama&orientation=landscape",
    tags: ["开机路透", "选角热议", "幕后花絮"],
  },
  {
    title: "跨年晚会拟邀名单三版本对比",
    date: "2026-09-05",
    views: "98.6万",
    comments: "1,745",
    count: "18 条",
    summary: "网传名单真假难辨，我们按时间线整理了三个版本的差异与重合，帮你少踩二手消息。",
    image: "https://readdy.ai/api/search-image?query=concert%20stage%20lights%20vivid%20performance%20scene%20stage%20production%20cinematic%20red%20accent%20cream%20background%20editorial%20clean%20composition&width=900&height=620&seq=gua-card-show&orientation=landscape",
    tags: ["跨年晚会", "拟邀名单", "版本对比"],
  },
  {
    title: "《雾里寻灯》首映口碑集锦",
    date: "2026-09-04",
    views: "154.3万",
    comments: "2,986",
    count: "31 条",
    summary: "一场首映引出两种声音，豆瓣短评与影评人观点并存，我们把核心观点分门别类。",
    image: "https://readdy.ai/api/search-image?query=cinema%20premiere%20red%20carpet%20dark%20theater%20moody%20film%20festival%20atmosphere%20deep%20red%20and%20cream%20editorial%20photography%20clean%20cinematic&width=900&height=620&seq=gua-card-movie&orientation=landscape",
    tags: ["点映口碑", "首映礼", "影评汇总"],
  },
  {
    title: "年度音乐盛典提名全解析",
    date: "2026-09-03",
    views: "211.7万",
    comments: "4,102",
    count: "36 条",
    summary: "哪些赛道最意外、哪些入围稳坐，评委偏好与行业风向都在这一篇讲清楚。",
    image: "https://readdy.ai/api/search-image?query=music%20award%20trophy%20gala%20stage%20warm%20spotlight%20elegant%20premium%20amber%20cream%20tones%20editorial%20clean%20minimal%20photography&width=900&height=620&seq=gua-card-music&orientation=landscape",
    tags: ["音乐盛典", "提名解析", "奖项预测"],
  },
  {
    title: "时尚周看秀造型复盘",
    date: "2026-09-02",
    views: "76.9万",
    comments: "1,108",
    count: "12 条",
    summary: "生图与精修对比之外，我们从配色与剪裁入手，看看这套造型为什么能出圈。",
    image: "https://readdy.ai/api/search-image?query=high%20fashion%20runway%20show%20elegant%20outfit%20minimal%20studio%20cream%20backdrop%20soft%20lighting%20editorial%20photography%20refined%20composition&width=900&height=620&seq=gua-card-fashion&orientation=landscape",
    tags: ["时尚周", "看秀造型", "生图复盘"],
  },
  {
    title: "经典剧重播翻红全盘点",
    date: "2026-09-01",
    views: "133.8万",
    comments: "2,651",
    count: "27 条",
    summary: "一部老剧为何突然回春？从配乐、演技到台词，逐条拆解它被重新发现的理由。",
    image: "https://readdy.ai/api/search-image?query=vintage%20television%20classic%20drama%20nostalgic%20retro%20camera%20set%20warm%20cozy%20cream%20amber%20editorial%20clean%20cinematic%20photography&width=900&height=620&seq=gua-card-remake&orientation=landscape",
    tags: ["经典重播", "名场面", "二次创作"],
  },
];

export interface FeatureArticle {
  tag: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  reads: string;
  accent: string;
  image: string;
}

export const featureArticles: FeatureArticle[] = [
  {
    tag: "深度观察",
    title: "一部戏的「长尾」，究竟是谁在替老剧回春？",
    excerpt: "重播数据逐年走高背后，是平台排播、弹幕文化还是新一代观众的回望心理？我们拆了三种可能的驱动。",
    author: "编辑部 · 阿茶",
    date: "2026-09-06",
    reads: "41.2万",
    accent: "text-primary-700 bg-primary-100",
    image: "https://readdy.ai/api/search-image?query=people%20watching%20television%20streaming%20device%20cozy%20living%20room%20evening%20warm%20lamp%20cream%20amber%20tone%20editorial%20lifestyle%20photography%20clean%20composition&width=1000&height=560&seq=gua-feat-1&orientation=landscape",
  },
  {
    tag: "红毯观察",
    title: "这套造型出圈的四个设计点，逐条拆给你看",
    excerpt: "看秀生图被夸不是偶然，配色克制、廓形利落，编辑部从专业视角还原它的走红逻辑。",
    author: "编辑部 · 阿青",
    date: "2026-09-05",
    reads: "28.7万",
    accent: "text-accent-900 bg-accent-100",
    image: "https://readdy.ai/api/search-image?query=runway%20fashion%20editorial%20model%20outfit%20details%20fabric%20texture%20minimal%20cream%20studio%20soft%20light%20elegant%20premium%20photography&width=1000&height=560&seq=gua-feat-2&orientation=landscape",
  },
  {
    tag: "行业向",
    title: "从路透到成片，粉丝社区在追什么？",
    excerpt: "当讨论从「是谁演」转向「怎么拍」，一场围绕创作过程的公共对话正在被重新定义。",
    author: "编辑部 · 阿泽",
    date: "2026-09-04",
    reads: "35.1万",
    accent: "text-secondary-900 bg-secondary-100",
    image: "https://readdy.ai/api/search-image?query=fans%20community%20social%20screen%20discussion%20creative%20process%20modern%20workspace%20phone%20and%20laptop%20warm%20cream%20editorial%20clean%20composition&width=1000&height=560&seq=gua-feat-3&orientation=landscape",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: "五1吃瓜的爆料来源靠谱吗？",
    a: "我们会优先采用可溯源、有时间线和多方交叉的信息，对网传消息会标注「网传待核实」，不把猜测当实锤写进标题，只做资讯汇总与整理。",
  },
  {
    q: "多久更新一次？",
    a: "站内内容由运营在每日分时段批量更新，重要动态会加急入库，尽量保证你打开首页时看到的是当天的核心热点，避免翻旧帖。",
  },
  {
    q: "合集里的图文能转载吗？",
    a: "转载请注明出处并保留原链接，涉及创作者的图文会标注整理性质，我们更建议你通过站内跳转查看原始讨论。",
  },
  {
    q: "遇到不实信息怎么办？",
    a: "每篇内容底部都有反馈入口，你可以一键标记存疑信息，我们会记录并核实，确实有误的会尽快下架或补充更正说明。",
  },
  {
    q: "需要注册才能浏览吗？",
    a: "不需要，站内全部内容免费开放浏览，评论与收藏功能也无需付费，保持轻量、干净的阅读体验即可。",
  },
];

export const trustPoints = [
  { icon: "ri-shield-check-line", title: "来源可溯", desc: "每条内容尽量保留时间线与出处线索，信息可回查。" },
  { icon: "ri-time-line", title: "同步更新", desc: "运营分时段批量刷新，热点动态不漏更、不积压。" },
  { icon: "ri-folder-2-line", title: "合集归档", desc: "热点按主题归档成合集，想看完整来龙去脉不必翻帖。" },
  { icon: "ri-error-warning-line", title: "网传标注", desc: "无法确证的消息明确标注「待核实」，不与实锤混淆。" },
];